export default {
  questions(state) {
    return state.questions;
  },
  totalQuestions(state) {
    return state.totalQuestions;
  }
};
